import { useRef, useState } from 'react';
import {useSwipeable} from 'react-swipeable';
import "./FellowTasters.css";

export const FellowTasters = () => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [carouselLeft, setCarouselLeft] = useState(-50.0);
  const carouselLeftRef = useRef(-50.0);

  const [currentMobileSlide, setCurrentMobileSlide] = useState(1);
  const [mobileCarouselLeft, setMobileCarouselLeft] = useState(0);
  const maxSlide = 3;
  const totalSlides = 6;
  const totalMobileSlides = 3;
  const [dot1Classes, setDot1Classes] = useState('fellowTasterDot fellowTasterDotFilled');
  const [dot2Classes, setDot2Classes] = useState('fellowTasterDot');
  const [dot3Classes, setDot3Classes] = useState('fellowTasterDot');

  const increaseMobileCarousel = () => {
    let newSlide = currentMobileSlide;
    let newLeft = mobileCarouselLeft;
    var carousel = document.getElementById('fellowTasterDesktopCarousel');
    if (newSlide<totalMobileSlides) {
        newSlide++;
        setCurrentMobileSlide(newSlide);
        newLeft -= 100.0;
        carouselLeftRef.current = newLeft;
        setMobileCarouselLeft(newLeft);
        carousel.style.left = newLeft + '%';
        updateDots(newSlide);
    }

  };

  const decreaseMobileCarousel = () => {
    let newSlide = currentMobileSlide;
    let newLeft = mobileCarouselLeft;
    var carousel = document.getElementById('fellowTasterDesktopCarousel');
    if (newSlide > 1) {
        newSlide--;
        setCurrentMobileSlide(newSlide);
        newLeft += 100.0;
        carouselLeftRef.current = newLeft;
        setMobileCarouselLeft(newLeft);
        carousel.style.left = newLeft + '%';
        updateDots(newSlide);
    }
  };


  const increaseDesktopCarousel = () => {
    let newSlide = currentSlide;
    let newLeft = carouselLeft;
    const slidesToShow = 2;
    const carousel = document.getElementById('fellowTasterDesktopCarousel');

    //style={{ left: `${carouselLeftRef.current}%` }}

    // if we are starting again (on the max slide plus 1), shift back to beginning
    if (newSlide == maxSlide + 1) {

        carousel.classList.remove('fellowTasterDesktopCarouselTransition');

        newSlide = 1;
        setCurrentSlide(newSlide);
        newLeft = -50.0;
        setCarouselLeft(newLeft);
        carouselLeftRef.current = newLeft;
        carousel.style.left = newLeft + '%';

        //flushCss(carousel);
        let offset = carousel.offsetHeight;
        carousel.classList.add('fellowTasterDesktopCarouselTransition');
    }


    if (newSlide<totalSlides-slidesToShow) {
        newSlide++;
        setCurrentSlide(newSlide);

        //var slides = document.getElementsByClassName("fellowTasterImage");
        newLeft -= 50.0;
        setCarouselLeft(newLeft);
        carouselLeftRef.current = newLeft;
        carousel.style.left = newLeft + '%';
        //showSlides();
    }
  }


  const decreaseDesktopCarousel = () => {
    let newSlide = currentSlide;
    let newLeft = carouselLeft;
    const slidesToShow = 2;
    const carousel = document.getElementById('fellowTasterDesktopCarousel');
    // if we are currently at the beginning we need to move to the end to simulate inifinite scrolling
    if (newSlide == 1) {
        //move to end
        carousel.classList.remove('fellowTasterDesktopCarouselTransition');

        newSlide = maxSlide + 1;
        setCurrentSlide(newSlide);
        newLeft = parseFloat(newSlide) * -50.0;
        setCarouselLeft(newLeft);
        carouselLeftRef.current = newLeft;
        carousel.style.left = newLeft.toString() + '%';

        let offset = carousel.offsetHeight;
        //flushCss(carousel);
        carousel.classList.add('fellowTasterDesktopCarouselTransition');
    }

    if (newSlide > 0) {
        newSlide--;
        setCurrentSlide(newSlide);
        newLeft += 50.0;
        setCarouselLeft(newLeft);
        carousel.style.left = newLeft + '%';
        //carouselLeftRef.current = newLeft;
    }
  }

  const updateDots = (newSlide) => {
    if (newSlide == 1) {
      setDot1Classes('fellowTasterDot fellowTasterDotFilled');
      setDot2Classes('fellowTasterDot');
      setDot3Classes('fellowTasterDot');
    } else if (newSlide == 2) {
      setDot1Classes('fellowTasterDot');
      setDot2Classes('fellowTasterDot fellowTasterDotFilled');
      setDot3Classes('fellowTasterDot');
    } else if (newSlide == 3) {
      setDot1Classes('fellowTasterDot');
      setDot2Classes('fellowTasterDot');
      setDot3Classes('fellowTasterDot fellowTasterDotFilled');
    }
  };

  const mobileDotClick = (slide) => {
    setCurrentMobileSlide(slide);
    const newLeft = -100 * (slide-1);
    setMobileCarouselLeft(newLeft);
    updateDots(slide);
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => increaseMobileCarousel(),
    onSwipedRight: () => decreaseMobileCarousel(),
    preventDefaultTouchmoveEvent: true
  });

  return (
    <div className="fellowTasters" >
      <div className="fellowTastersContainer">
        <div className="fellowTastersHeader">
            <div className="fellowTastersTitle" >
            Meet a few of our expert tasters
            </div>

            <div className="fellowTastersBody" >
            Each week our panel of tasters tries dozens of coffees and agrees on one. No roast goes untasted, unexamined, and un-debated to exhaustive lengths.
            </div>
        </div>
        <div className="fellowTastersImages" >

            <div id="tasterCarouselLeft" className={"toggle tasterCarouselLeft"} data-toggle='prev' onClick={decreaseDesktopCarousel}>
                <img alt="left" className="tasterCarouselLeftImg" src="/images/landing/Illustrations/Various_Illustrations/white_arrow_right.svg"/>
            </div>
            <div id="tasterCarouselRight" className={"toggle tasterCarouselRight"} data-toggle='next' onClick={increaseDesktopCarousel}>
                <img alt="right" src="/images/landing/Illustrations/Various_Illustrations/white_arrow_right.svg"/>
            </div>

         <div className="fellowTasterDesktopCarouselOuter">
          <div id="fellowTasterDesktopCarousel" className={"fellowTasterDesktopCarousel fellowTasterDesktopCarouselTransition"} style={{left: '-50.0%'}}>

            {/* repeat first */}
            <div className="fellowTasterImageContainer" >
                <div className="fellowTasterImage">
                    <img alt="Eric" className="fellowTasterImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Fellow_Tasting_Panel/eric_new.webp"} width="100%" height="auto" />
                    <div className={"fellowTasterNameBubble fellowTasterEricColor"}></div>
                    <div className="fellowTasterNameText">ERIC</div>
                    <img alt="Bubble" className="fellowTasterDescBubble" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/vector.svg"}/>
                    <div className="fellowTasterDescText" style={{color: "#ff684b"}}>
                    The Midnight<br/>Brewer 🌙
                    </div>
                </div>
                <div className="fellowTasterText" >
                    Eric is the Roaster Partnerships Manager at Fellow and has a boundless obsession with coffee. He once ran a heavy-metal themed pop-up coffee bar called Grindpour.
                </div>
            </div>

            <div className="fellowTasterImageContainer" >
                <div className="fellowTasterImage">
                    <img alt="Eric" className="fellowTasterImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Fellow_Tasting_Panel/eric_new.webp"} width="100%" height="auto" />
                    <div className={"fellowTasterNameBubble fellowTasterEricColor"}></div>
                    <div className="fellowTasterNameText">ERIC</div>
                    <img alt="Bubble" className="fellowTasterDescBubble" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/vector.svg"}/>
                    <div className="fellowTasterDescText" style={{color: "#ff684b"}}>
                    The Midnight<br/>Brewer 🌙
                    </div>
                </div>
                <div className="fellowTasterText" >
                    Eric is the Roaster Partnerships Manager at Fellow and has a boundless obsession with coffee. He once ran a heavy-metal themed pop-up coffee bar called Grindpour.
                </div>
            </div>
            <div className="fellowTasterImageContainer" >
                <div className="fellowTasterImage">
                    <img alt="Hailie" className="fellowTasterImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Fellow_Tasting_Panel/hailie_new.webp"} width="100%" height="auto" />
                    <div className={"fellowTasterNameBubble fellowTasterHailieColor"}></div>
                    <div className="fellowTasterNameText">HAILIE</div>
                    <img alt="Bubble" className="fellowTasterDescBubble" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/vector.svg"}/>
                    <div className="fellowTasterDescText" style={{color: "#cde2ec"}}>
                    The Seasoned<br/>Barista 💪
                    </div>
                </div>
                <div className="fellowTasterText" >
                    Hailie is Store Lead at the Fellow Store + Playground in San Francisco. She loves coffee science, socially responsible production, and calling "espresso" 'spro.
                </div>
            </div>
            <div className="fellowTasterImageContainer" >
                <div className="fellowTasterImage">
                    <img alt="Nick" className="fellowTasterImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Fellow_Tasting_Panel/nick_new.webp"} width="100%" height="auto" />
                    <div className={"fellowTasterNameBubble fellowTasterNickColor"}></div>
                    <div className="fellowTasterNameText">NICK</div>
                    <img alt="Bubble" className="fellowTasterDescBubble" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/vector.svg"}/>
                    <div className="fellowTasterDescText" style={{color: "#ffcea1"}}>
                    The Gearhead<br/>🛠
                    </div>
                </div>
                <div className="fellowTasterText" >
                    Nick is Fellow's Director of Mechanical Engineering and Head of R&D. He's also been a professional barista, roaster, and espresso machine repair technician.
                </div>
            </div>

            {/* repeat first two */}
            <div className="fellowTasterImageContainer" >
                <div className="fellowTasterImage">
                    <img alt="Eric" className="fellowTasterImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Fellow_Tasting_Panel/eric_new.webp"} width="100%" height="auto" />
                    <div className={"fellowTasterNameBubble fellowTasterEricColor"}></div>
                    <div className="fellowTasterNameText">ERIC</div>
                    <img alt="Bubble" className="fellowTasterDescBubble" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/vector.svg"}/>
                    <div className="fellowTasterDescText" style={{color: "#ff684b"}}>
                    The Midnight<br/>Brewer 🌙
                    </div>
                </div>
                <div className="fellowTasterText" >
                    Eric is the Roaster Partnerships Manager at Fellow and has a boundless obsession with coffee. He once ran a heavy-metal themed pop-up coffee bar called Grindpour.
                </div>
            </div>
            <div className="fellowTasterImageContainer" >
                <div className="fellowTasterImage">
                    <img alt="Hailie" className="fellowTasterImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Fellow_Tasting_Panel/hailie_new.webp"} width="100%" height="auto" />
                    <div className={"fellowTasterNameBubble fellowTasterHailieColor"}></div>
                    <div className="fellowTasterNameText">HAILIE</div>
                    <img alt="Bubble" className="fellowTasterDescBubble" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/vector.svg"}/>
                    <div className="fellowTasterDescText" style={{color: "#cde2ec"}}>
                    The Seasoned<br/>Barista 💪
                    </div>
                </div>
                <div className="fellowTasterText" >
                    Hailie is Store Lead at the Fellow Store + Playground in San Francisco. She loves coffee science, socially responsible production, and calling "espresso" 'spro.
                </div>
            </div>
          </div>
         </div>
        </div>

        <div id="fellowTastersCarousel" className="fellowTastersCarousel">
          <div id="fellowTasterCarouselImages" className="fellowTasterCarouselImages" style={{ left: `${mobileCarouselLeft}%` }} {...swipeHandlers}>
            <div className="fellowTasterImageContainerMobile" >
                <div className="fellowTasterImage">
                    <img alt="Eric" className="fellowTasterImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Fellow_Tasting_Panel/eric_new.webp"} width="100%" height="auto" />
                    <div className={"fellowTasterNameBubble fellowTasterEricColor"}></div>
                    <div className="fellowTasterNameText">ERIC</div>
                    <img alt="Bubble" className="fellowTasterDescBubble" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/vector.svg"}/>
                    <div className="fellowTasterDescText" style={{color: "#ff684b"}}>
                    The Midnight<br/>Brewer 🌙
                    </div>
                </div>

                <div className="fellowTasterText" >
                    Eric is the Roaster Partnerships Manager at Fellow and has a boundless obsession with coffee. He once ran a heavy-metal themed pop-up coffee bar called Grindpour.
                </div>
            </div>

            <div className="fellowTasterImageContainerMobile" >
                <div className="fellowTasterImage">
                    <img alt="Hailie" className="fellowTasterImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Fellow_Tasting_Panel/hailie_new.webp"} width="100%" height="auto" />
                    <div className={"fellowTasterNameBubble fellowTasterHailieColor"}></div>
                    <div className="fellowTasterNameText">HAILIE</div>
                    <img alt="Bubble" className="fellowTasterDescBubble" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/vector.svg"}/>
                    <div className="fellowTasterDescText" style={{color: "#cde2ec"}}>
                    The Seasoned<br/>Barista 💪
                    </div>
                </div>
                <div className="fellowTasterText" >
                    Hailie is Store Lead at the Fellow Store + Playground in San Francisco. She loves coffee science, socially responsible production, and calling "espresso" 'spro.
                </div>
            </div>

            <div className="fellowTasterImageContainerMobile" >
                <div className="fellowTasterImage">
                    <img alt="Nick" className="fellowTasterImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Fellow_Tasting_Panel/nick_new.webp"} width="100%" height="auto" />
                    <div className={"fellowTasterNameBubble fellowTasterNickColor"}></div>
                    <div className="fellowTasterNameText">NICK</div>
                    <img alt="Bubble" className="fellowTasterDescBubble" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/vector.svg"}/>
                    <div className="fellowTasterDescText" style={{color: "#ffcea1"}}>
                    The Gearhead<br/>🛠
                    </div>
                </div>
                <div className="fellowTasterText" >
                    Nick is Fellow's Director of Mechanical Engineering and Head of R&D. He's also been a professional barista, roaster, and espresso machine repair technician.
                </div>
            </div>
          </div>
        </div>

          <div className="fellowTasterDotsContainer">
                <div className="fellowTasterDots">
                    <div id="tasterDot1" className={dot1Classes} onClick={() => mobileDotClick(1)}></div>
                    <div id="tasterDot2" className={dot2Classes} onClick={() => mobileDotClick(2)}></div>
                    <div id="tasterDot3" className={dot3Classes} onClick={() => mobileDotClick(3)}></div>
                </div>
          </div>
      </div>
    </div>
  );
}

